import type { FC } from "react";

import { IconBarchart } from "../icons/icon-barchart";
import { IconChartUp } from "../icons/icon-chart-up";
import { IconCheckmark } from "../icons/icon-checkmark";
import { IconHeart } from "../icons/icon-heart";
import { IconStars } from "../icons/icon-stars";
import { PayPlan } from "../payment-plan";

export const VariantDefault: FC<{ plan: PayPlan }> = ({ plan }) => {
  return (
    <PayPlan.Card>
      <PayPlan.Label>{plan.shortDescription}</PayPlan.Label>
      <PayPlan.Title>Побачити мої результати</PayPlan.Title>
      <PayPlan.Description>
        Дає змогу побачити, як ви почуваєтесь насправді
      </PayPlan.Description>
      <PayPlan.Price plan={plan} />
      <PayPlan.Benefits>
        <PayPlan.BenefitsItem Icon={IconChartUp}>
          Оцінку вашого стану (до 55+ показників)
        </PayPlan.BenefitsItem>
        <PayPlan.BenefitsItem Icon={IconCheckmark}>
          Зрозумілі пояснення показників
        </PayPlan.BenefitsItem>
        <PayPlan.BenefitsItem Icon={IconStars}>
          Персоналізовані рекомендації
        </PayPlan.BenefitsItem>
        <PayPlan.BenefitsItem Icon={IconHeart}>
          Завантаження результатів
        </PayPlan.BenefitsItem>
        <PayPlan.BenefitsItem Icon={IconBarchart}>
          Динаміка змін показників
        </PayPlan.BenefitsItem>
      </PayPlan.Benefits>
      <PayPlan.Action plan={plan}>Отримати повні результати</PayPlan.Action>
    </PayPlan.Card>
  );
};
